import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { SurveyQuestion, SurveyQuestionCategory } from '@ps/survey-utils';

import {
  GetAdvancedTargetingQuestionsResponseDto,
  SurveyCategoriesResponseDto,
} from './dtos/survey-question.dto';
import { SurveyCategoryMapper } from './mappers/survey-category.mapper';
import { SurveyQuestionMapper } from './mappers/survey-question.mapper';
import { SurveyQuestionsPayloadMapper } from './mappers/survey-question.payload.mapper';

@Injectable({ providedIn: 'root' })
export class SurveyQuestionApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);

  private readonly _mapper = new SurveyQuestionMapper();
  private readonly _payloadMapper = new SurveyQuestionsPayloadMapper();
  private readonly _categoryMapper = new SurveyCategoryMapper();

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _attributesUrl = `${this._baseUrl}/buyers/v3/attributes`;
  private readonly _advancedQuestionsUrl = `${this._baseUrl}/questions/v2/advance`;

  public getQuestions(
    search: string,
    categoryIds: number[],
  ): Observable<SurveyQuestion[]> {
    const params = new HttpParams({
      fromObject: this._payloadMapper.toPayload({ search, categoryIds }),
    });

    return this._http
      .get<GetAdvancedTargetingQuestionsResponseDto>(
        this._advancedQuestionsUrl,
        { params },
      )
      .pipe(map((response) => this._mapper.fromDtoList(response.questions)));
  }

  public categories(): Observable<SurveyQuestionCategory[]> {
    return this._http
      .get<SurveyCategoriesResponseDto>(`${this._attributesUrl}/categories/all`)
      .pipe(map((response) => this._categoryMapper.fromDtoList(response)));
  }
}
